export default __webpack_public_path__ + "static/media/image-product-1.520cc50b.jpg";